import styled from 'styled-components'
import Button from 'components/Button'

export const ChangeDiscountButton = styled(Button).attrs({ variant: 'secondary' })`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 6px;
  margin-left: 1em;
  width: auto;
  min-width: auto;
  font-size: ${props => props.theme.fontSizes[0]};

  svg {
    margin-right: 6px;
  }
`
